'use client'

import { Button } from '@/components/ui/button'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'

interface ModalInfoX2CoolCashProps {
  onClose?: () => void
}

export const ModalInfoX2CoolCash = ({ onClose }: ModalInfoX2CoolCashProps) => {
  const isMobile = useIsMobileClient()
  const imageSrc = isMobile
    ? '/image/April2024/mceclip2_42.png'
    : '/image/April2024/mceclip0_46.png'

  const imageSize = isMobile
    ? { width: 375, height: 400 }
    : { width: 800, height: 300 }

  return (
    <div className='no-scrollbar max-h-[80vh] w-full max-w-3xl overflow-y-auto'>
      <div className='mb-6'>
        <h2 className='text-2xl font-bold'>Happy Friday X2 CoolCash</h2>
        <p className='mt-2 text-base text-gray-600'>
          Thứ 6 hàng tuần, Hội viên CoolClub được nhận đôi hoàn tiền CoolCash
          khi đăng nhập và mua hàng trên website Coolmate.
        </p>
      </div>

      <div className='mt-4'>
        <Image
          src={ImageHelper.getImageUrl(imageSrc)}
          alt='Bảng quy đổi CoolCash'
          width={imageSize.width}
          height={imageSize.height}
          className='w-full'
          unoptimized
          priority
        />
      </div>

      <div className='mt-4 text-sm text-gray-500'>
        * Chương trình áp dụng thứ Sáu hàng tuần, bắt đầu từ 19/04/2024.
      </div>

      <div className='mt-2 flex flex-col items-center justify-center gap-4 rounded-2xl bg-neutral-200 p-4 text-sm'>
        <div className='text-center font-bold'>
          Để không bỏ lỡ hoàn tiền CoolCash cho bất kỳ đơn hàng nào:
        </div>
        <Button className='w-full' variant={'black'}>
          THAM GIA COOLCLUB
        </Button>
        <Button variant='outline-neutral' className='w-full' onClick={onClose}>
          ĐĂNG NHẬP
        </Button>
      </div>
    </div>
  )
}
